// extracted by mini-css-extract-plugin
export default {"AllTogether_wrapper":"AllTogether_AllTogether_wrapper__WhzPs","emmpty_p_tag":"AllTogether_emmpty_p_tag__aQ3iI"};